<template>
  <div class="message-page page">
    <van-nav-bar :title="$t('my.inbox_message') || '站内信'" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data') || 'No Data'" />
        <div v-else class="message-list">
          <div
            class="message-item"
            v-for="item in list"
            :key="item.id"
            @click="openDetail(item)"
          >
            <div class="item-icon">
              <van-icon name="envelop-o" />
            </div>
            <div class="item-main">
              <div class="item-top">
                <span class="title" :class="{ unread: !item.is_read }">{{ item.title }}</span>
                <span class="dot" v-if="!item.is_read"></span>
              </div>
              <div class="item-preview">{{ item.content }}</div>
              <div class="item-time">{{ item.create_time }}</div>
            </div>
            <van-icon name="arrow" class="item-arrow" />
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <MessageDialog
      v-model="showDetail"
      :title="current ? current.title : ''"
      :content="current ? current.content : ''"
      :time="current ? current.create_time : ''"
      :confirm-text="$t('my.message_close') || '关闭'"
      :close-on-click-overlay="true"
      @confirm="onDetailClose"
    />
  </div>
</template>

<script>
import MessageDialog from '@/components/MessageDialog.vue'

export default {
  name: 'Message',
  components: {
    MessageDialog,
  },
  data() {
    return {
      isLoading: false,
      list: [],
      showDetail: false,
      current: null,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getList() {
      this.$http({
        method: 'get',
        url: 'message_list',
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data || [];
        }
      });
    },
    openDetail(item) {
      this.current = item;
      this.showDetail = true;
      if (!item.is_read) {
        this.$http({
          method: 'post',
          url: 'message_mark_read',
          data: { id: item.id },
        }).then(res => {
          if (res.code === 200) {
            item.is_read = 1;
          }
        });
      }
    },
    onDetailClose() {
      this.showDetail = false;
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.getList();
        this.$toast(this.$t('reservation.refresh'));
      }, 500);
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    this.getList();
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';
.message-item {
  display: flex;
  align-items: center;
  width: 94%;
  margin: 0 auto 10px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #fff;
  color: #333;
  &:active { background: #fafafa; }
}
.item-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(30deg, #8175eb, #de55a1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  .van-icon { font-size: 20px; color: #fff; }
}
.item-main { flex: 1; min-width: 0; }
.title { font-size: 15px; color: #666; }
.title.unread { color: #333; font-weight: 600; }
.item-preview { margin-top: 4px; font-size: 13px; color: #999; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.item-time { margin-top: 4px; font-size: 12px; color: #9a8fbf; }
.dot { width: 8px; height: 8px; border-radius: 50%; background: #ff4d4f; margin-left: 8px; }
.item-arrow { color: #ccc; font-size: 14px; margin-left: 8px; }
</style>
